export default "__VITE_ASSET__BEMYfdD7__"